import {CONFIG} from '@/config';
import {httpService} from '@/services';
import {ContextEnum} from '@/enums/context.enum';
import LogActionModel from '@/utils/logAction.model';

export interface ITraceLogAccess {
  generationTracking(context: string): void;
  logAction(context: ContextEnum, action: string, parameters: string): void;
}

export class TraceLogAccessService implements ITraceLogAccess {
  public generationTracking(context: string): void {
    httpService.http
        .post(`${CONFIG.URL.NEODASH_API}/api/neodash/log/access/${context}`)
        .then(() => {
        })
        .catch(err => {
          console.log('ERROR: ', err);
        });
  }

  public async logAction(context: ContextEnum, action: string, parameters: string = '') {
    if (CONFIG.NODE_ENV.toLowerCase() !== 'production') {
      return;
    }

    httpService.http
      .post(`${CONFIG.URL.CTRL_PANEL_API}/system/log`, new LogActionModel(context, action, parameters))
      .then(() => {
      })
      .catch(err => {
        console.log('ERROR: ', err);
      });
  }
}

export const traceLogAccess = new TraceLogAccessService();
